export const universityOnboardingRoutes = {
    path: "university-onboarding",
    name: "university onboarding",
    component: () => import("@/pages/university/UniversityOnboardingIndex.vue"),
    meta: {
        label: "University Onboarding Center"
    }
}